<template>
    <table class="table">
        <thead>
            <tr>
                <th v-for="row in neededData" :key="row.title">{{ row.title }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td v-for="row in neededData">{{ row.value }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'contact-edit-catchlight-table',
    props: {
        enrichmentData: {
            type: Object,
            required: true
        },
    },
    computed: {
        neededData() {
            const CatchlightScoreObject = this.enrichmentData.features.find(feature => feature.id === 'CL_1_6_1')
            const InvestableAssetsObject = this.enrichmentData.features.find(feature => feature.id === 'CL_1_5')
            const IncomeRangeObject = this.enrichmentData.features.find(feature => feature.id === 'CL_1_82')
            const EstimatedHomeValueObject = this.enrichmentData.features.find(feature => feature.id === 'CL_1_3')
            const ProjectedClientRevenueObject = this.enrichmentData.features.find(feature => feature.id === 'CL_1_73')
            const numberWithCommas = (x) => {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            const createRange = (value) => {
                if(value && value.minimum && value.maximum) {
                    return `$${numberWithCommas(Math.round(value.minimum))} - $${numberWithCommas(Math.round(value.maximum))}`
                }
                if(value && value.minimum && !value.maximum) {
                    return `$${numberWithCommas(Math.round(value.minimum))}`
                }

                if(value && value.maximum && !value.minimum) {
                    return `$${numberWithCommas(Math.round(value.maximum))}`
                }
                return 'N/A'
            }
            return [
                {
                    title: CatchlightScoreObject.name,
                    value: Math.round(CatchlightScoreObject.value)
                },
                {
                    title: InvestableAssetsObject.name,
                    value: createRange(InvestableAssetsObject.value)
                },
                {
                    title: IncomeRangeObject.name,
                    value: createRange(IncomeRangeObject.value)
                },
                {
                    title: EstimatedHomeValueObject.name,
                    value: createRange(EstimatedHomeValueObject.value)
                },
                {
                    title: ProjectedClientRevenueObject.name,
                    value: createRange(ProjectedClientRevenueObject.value)
                },
                {
                    title: 'Enriched As-Of Date',
                    value: moment(this.enrichmentData.updated_at || this.enrichmentData.created_at).format('MM/DD/YYYY')
                }
            ]
        }
    },
}
</script>

<style lang="scss" scoped></style>
